// The change card in the platform agent's panel (D5). Wording from the Amigo design's copy sheet (Card, Rejecting,
// Summary first, Row status, Applying, Done, Rejected, Replaced, Changed in the meantime, Partly failed).
export default {
  // A password the shop created on approval, shown once (contracts §4 `revealed`).
  secret: {
    show: 'Passwort anzeigen',
    hide: 'Passwort verbergen',
    copy: 'Kopieren',
    copied: 'Kopiert',
    once: 'Nur jetzt sichtbar. Kopier es und bewahr es sicher auf.',
  },
  loading: 'Die Änderung wird geladen…',
  load_failed: 'Ich konnte diese Änderung nicht laden.',
  load_retry: 'Erneut versuchen',
  // While the agent can't be reached, instead of the card's skeleton (QA119).
  load_waiting: {
    amigo: 'Diese Änderung erscheint hier, sobald Amigo wieder da ist. Es hat sich nichts geändert.',
    assistant: 'Diese Änderung erscheint hier, sobald der Assistent wieder da ist. Es hat sich nichts geändert.',
  },
  // An approve that found the set approved already, in another tab or by the agent's follow-up (QA19).
  already_approved: 'Das war schon freigegeben, es war nichts mehr zu tun.',
  action_failed: 'Das hat nicht geklappt, es wurde nichts geändert. Versuch es gleich noch mal.',
  removed: 'Entfernt',
  retry: 'Erneut versuchen',
  retry_one: '{{name}} erneut versuchen',
  // The message the panel sends the agent with the card's outcome (contracts §5 clientContext.changeSet).
  message: {
    approved: 'Freigegeben.',
    retried: 'Erneut versucht.',
    rejected: 'Abgelehnt.',
    // A restaurant skipped on a card with several restaurants (D18): its own set is rejected with this reason.
    skipped_restaurant: 'Auf der Karte übersprungen.',
  },
  done: {
    summary_one: 'Erledigt. {{count}} Änderung übernommen.',
    summary_other: 'Erledigt. {{count}} Änderungen übernommen.',
    skipped_one: '{{count}} übersprungen, dort hat sich nichts geändert.',
    skipped_other: '{{count}} übersprungen, dort hat sich nichts geändert.',
  },
  partial: {
    summary_one: '{{applied}} von {{approved}} Änderungen übernommen, {{count}} nicht.',
    summary_other: '{{applied}} von {{approved}} Änderungen übernommen, {{count}} nicht.',
    detail_one: 'Die {{applied}} sind gespeichert. Bei der {{count}} unten hat sich nichts geändert.',
    detail_other: 'Die {{applied}} sind gespeichert. Bei den {{count}} unten hat sich nichts geändert.',
  },
  stale: {
    summary: '{{applied}} von {{approved}} Änderungen übernommen.',
    detail_one: '{{count}} wurde inzwischen von jemand anderem geändert.',
    detail_other: '{{count}} wurden inzwischen von jemand anderem geändert.',
    reason:
      '{{name}} hat das um {{time}} auf {{value}} geändert, bevor du freigegeben hast, deshalb habe ich es nicht übernommen. Hier noch mal ausgehend vom neuen Wert:',
    decided_done:
      '{{name}} hat das um {{time}} auf {{value}} geändert, bevor du freigegeben hast, deshalb habe ich es nicht übernommen. Der neue Vorschlag wurde auf seiner eigenen Karte freigegeben.',
    decided_rejected:
      '{{name}} hat das um {{time}} auf {{value}} geändert, bevor du freigegeben hast, deshalb habe ich es nicht übernommen. Der neue Vorschlag wurde abgelehnt.',
    decided_replaced:
      '{{name}} hat das um {{time}} auf {{value}} geändert, bevor du freigegeben hast, deshalb habe ich es nicht übernommen. Der neue Vorschlag wurde durch eine neuere Karte ersetzt.',
    decided_expired:
      '{{name}} hat das um {{time}} auf {{value}} geändert, bevor du freigegeben hast, deshalb habe ich es nicht übernommen. Der neue Vorschlag ist abgelaufen.',
  },
  undo_partly_one: '{{count}} davon lässt sich nicht rückgängig machen.',
  undo_partly_other: '{{count}} davon lassen sich nicht rückgängig machen.',
  undone: {
    summary_one: 'Rückgängig gemacht. Die {{count}} Änderung ist wieder wie vorher.',
    summary_other: 'Rückgängig gemacht. Die {{count}} Änderungen sind wieder wie vorher.',
    detail: 'Auch das steht im Amigo-Protokoll und im Bearbeitungsverlauf.',
    partly_summary: 'Teilweise rückgängig gemacht. {{undone}} von {{count}} Änderungen sind wieder wie vorher.',
    partly_changed_one: '{{count}} wurde inzwischen von jemand anderem geändert und bleibt deshalb so.',
    partly_changed_other: '{{count}} wurden inzwischen von jemand anderem geändert und bleiben deshalb so.',
    partly_kept_one: '{{count}} war schon wieder wie vorher.',
    partly_kept_other: '{{count}} waren schon wieder wie vorher.',
    partly_cannot_one: '{{count}} lässt sich nicht rückgängig machen, etwa ein Löschen, und bleibt deshalb so.',
    partly_cannot_other: '{{count}} lassen sich nicht rückgängig machen, etwa ein Löschen, und bleiben deshalb so.',
    partly_left_one: '{{count}} bleibt so.',
    partly_left_other: '{{count}} bleiben so.',
  },
  summary: {
    group_one: '{{count}} Gericht: {{reason}}',
    group_other: '{{count}} Gerichte: {{reason}}',
    group_names_more_one: '{{names}} und {{count}} weiteres',
    group_names_more_other: '{{names}} und {{count}} weitere',
    average: '{{amount}} pro Gericht im Schnitt',
    needs_look: 'Bitte prüfen',
    nothing_else: 'Sonst ändert sich nichts',
  },
  labels: {
    waiting: 'Ausstehend',
    skip: 'Überspringen',
    unskip: 'Doch übernehmen',
    approve_all: 'Alle freigeben',
    approve_one: '{{count}} freigeben',
    approve_other: '{{count}} freigeben',
    approve_all_count_one: 'Alle {{count}} freigeben',
    approve_all_count_other: 'Alle {{count}} freigeben',
    approve_row: 'Freigeben',
    reject: 'Verwerfen',
    reject_confirm: 'Ablehnen',
    back: 'Zurück',
    why: {
      amigo: 'Warum nicht? (optional, Amigo liest das)',
      assistant: 'Warum nicht? (optional, der Assistent liest das)',
    },
    hint: 'Oder antworte unten, um etwas zu ändern.',
    show_all_one: 'Alle {{count}} Änderungen zeigen',
    show_all_other: 'Alle {{count}} Änderungen zeigen',
    show_less: 'Weniger zeigen',
    applying_one: '{{count}} Änderung wird übernommen…',
    applying_other: '{{count}} Änderungen werden übernommen…',
    high_impact: 'Große Wirkung',
    done: 'Erledigt',
    running: 'Läuft',
    show_changes: 'Änderungen zeigen',
    hide_changes: 'Änderungen ausblenden',
    rows: {
      skipped: 'Übersprungen',
      applied: 'Übernommen',
      failed: 'Nicht übernommen',
      changed: 'Inzwischen geändert',
      kept: 'Bleibt unverändert',
    },
    history: {
      amigo: 'Im Amigo-Protokoll öffnen',
      assistant: 'Im Protokoll des Assistenten öffnen',
    },
    undo: 'Rückgängig',
    to: 'zu',
    from: 'von',
    rejected: 'Abgelehnt',
    replaced: 'Ersetzt',
    expired: 'Abgelaufen',
  },
};
